import classNames from "classnames";

import {Service} from "@/lib/types/checks.ts";
import {uptimeGradeCSSClass} from "@/pages/dashboard/display/dashboardUtils.ts";

import styles from "@/pages/dashboard/display/components/CheckCard.module.scss";

export const CheckResponsePagespeed = ({service}: {service: Service}) => (
  <>
    <div className={styles.checkCardStatName}>Uptime Grade</div>
    <div className={classNames(styles.checkCardStatValue, uptimeGradeCSSClass(service.cached_uptime_grade))}>
      {service.cached_uptime_grade}
    </div>
  </>
);
